import {
  Alert,
  Box,
  Button,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import LoginWithGoogleButton from "./components/LoginWithGoogleButton";
import { useAuth } from "./contexts/AuthContext";
import { useFirebase } from "./contexts/FirebaseContext";

const SignIn = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const returnUrl = location.state?.returnUrl || '/dashboard';
  const { auth } = useFirebase();
  
  return (
    <Box>
      {currentUser && navigate(returnUrl)}

      {!currentUser && (
        <>
          {location.state?.message && (
            <Alert severity="info" sx={{ mb: 2 }}>
              {location.state.message}
            </Alert>
          )}
          
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 4, maxWidth: '500px', mx: 'auto', px: 2 }}>
              <Button 
                variant="contained" 
                color="primary"
                size="large"
                sx={{ 
                  py: 2.5, 
                  fontSize: '1.3rem',
                  fontWeight: 'bold',
                  boxShadow: 3,
                  width: '100%',
                  alignSelf: 'center'
                }}
                onClick={() => navigate("/signin/whatsapp")}
              >
                Continue with WhatsApp
              </Button>

              <LoginWithGoogleButton 
                auth={auth}
                variant="outlined"
                color="primary"
                sx={{ py: 2 }}
              />

              <Button 
                variant="outlined" 
                color="primary"
                size="large"
                fullWidth
                sx={{ py: 2 }}
                onClick={() => navigate("/signin/email")}
              >
                Continue with Email
              </Button>
            </Box>
        </>
      )}
    </Box>
  );
};

export default SignIn;
